import init from './init';
import modalSection from './sections/modal';
import headerSection from './sections/header';
import footerSection from './sections/footer';
import notificationSection from './sections/notification';
import hero from './sections/hero';
import cards from './sections/cards';
import muuri from './pages/muuri';
import projects from './pages/projects';
import news from './pages/news';

init();
modalSection();
headerSection();
footerSection();
notificationSection();
hero();
cards();
muuri();
projects();
news();



// WEBPACK FOOTER //
// ./source/scripts/main.js